<template>
  <v-container>
    <v-btn fab fixed dark bottom right color="primary" @click="openCreateModel">
      <v-icon>add</v-icon>
    </v-btn>
    <br />
    <v-data-table
      :headers="headers"
      :items="data"
      :search="search"
      sort-by="calories"
      class="elevation-1"
    >
      <template v-slot:top>
        <v-toolbar flat color="white">
          <v-spacer></v-spacer>
          <v-col cols="12" sm="4">
            <v-text-field
              v-model="search"
              append-icon="search"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
          </v-col>
        </v-toolbar>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-icon medium class="mr-2" @click="openEditModel(item)">
          edit
        </v-icon>
        <v-icon medium @click="opendeleteModel(item)">
          delete
        </v-icon>
      </template>
      <template v-slot:item.action_details="{ item }">
        <v-btn color="primary" small @click="openCreateModel(item)"
          >View Actions</v-btn
        >
      </template>
    </v-data-table>
    <SkillTestingModel
      @openmodel="closeModel"
      v-if="skillTestingModal"
      :btnTitle="btn"
      :title="modalTitle"
      :item="itemData"
      @getSkillTestingQuestions="getSkillTestingQuestions"
      :deleteModal="showModelType"
      :tier_id="tier_id"
    ></SkillTestingModel>
  </v-container>
</template>

<script>
import api from '@/clients/prizingapi/skill_testing_questions'
import header from './tableColumns'
import { mapActions, mapGetters } from 'vuex'

export default {
  components: {
    SkillTestingModel: () => import('./skill-testing-model')
  },
  props: ['tier_id'],
  data: () => ({
    data: [],
    search: '',
    skillTestingModal: false,
    modalTitle: ' ',
    btn: '',
    headers: header,
    itemData: [],
    showModelType: true
  }),
  mounted () {
    this.getSkillTestingQuestions()
  },

  computed: {
    ...mapGetters({
      vg_activeBusinessBrandingAndLogo: 'auth/activeBusinessBrandingAndLogo'
    })
  },
  methods: {
    getSkillTestingQuestions (event) {
      this.spinner(true)
      api
        .getSkillTestingQuestions()
        .then(res => {
          this.data = res.data.payload
          this.skillTestingModal = false
          this.spinner(false)
        })
        .catch(error => {
          this.spinner(false)
          return error
        })
    },
    openEditModel (val) {
      this.modalTitle = 'Edit Skill Testing Questions'
      this.btn = 'Update'
      this.skillTestingModal = true
      this.itemData = val
      this.showModelType = true
    },
    openCreateModel () {
      this.itemData = { }
      this.modalTitle = 'Create Skill Testing Questions'
      this.btn = 'Save'
      this.skillTestingModal = true
      this.showModelType = true
      this.tier_id = this.tier_id
    },
    opendeleteModel (val) {
      this.modalTitle = 'Delete SkillTesting '
      this.btn = 'Delete'
      this.skillTestingModal = true
      this.itemData = val
      this.showModelType = false
    },
    closeModel () {
      this.skillTestingModal = false
    },
    ...mapActions({
      va_setActiveBusinessBranding: 'auth/setActiveBusinessBranding'
    })
  }
}
</script>
